module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/pencil-icon-f8509e9503edf13b4b9921e3f0b9ce90.png";